import React from "react";

import pasos12 from "../../images/pasos12.png";
import pasos34 from "../../images/pasos34.png";
import icoApp from "../../images/icono-apps.png";
import icoBaz from "../../images/icono-bazteca.png";
import icoInstall from "../../images/icono-instalar.png";
import icoOfertas from "../../images/icono-ofertas.png";

export default function Mobile({ common: { data } }) {
  return (
    <div className="layout-steps mobile">
      <div className="excerpt2">
        Te invitamos a conocer otras opciones de crédito con uno de nuestros
        socios.
      </div>
      <p>
        Sigue las instrucciones para descargar la app y continuar con el proceso
        desde tu móvil:
      </p>
      <img src={pasos12} alt="steps" className="steps-img" />

      <ul className="steps">
        <li>
          Ingresa a tu tienda de apps preferida
          <img src={icoApp} alt="ico" />
        </li>
        <li>
          Busca Banco Azteca <img src={icoBaz} alt="ico" />
        </li>
      </ul>

      <img src={pasos34} alt="steps" className="steps-img" />
      <ul className="steps">
        <li>
          Selecciona Instalar
          <img src={icoInstall} alt="ico" />
        </li>
        <li>
          Sigue los pasos para registrarte y ver sus ofertas de crédito
          <img src={icoOfertas} alt="ico" />
        </li>
      </ul>
    </div>
  );
}
